export const SWITCH_THEME = 'SWITCH_THEME'
export const LOGIN_USER_DETAILS = 'LOGIN_USER_DETAILS'
export const LOGIN_BUSINESS_DETAILS = 'LOGIN_BUSINESS_DETAILS'
export const CHECK_OUT_DETAIL = 'CHECK_OUT_DETAIL'
export const SEARCH = 'SEARCH'
export const IMAGE_SEARCH = 'IMAGE_SEARCH'
export const SAVE_SEARCH_IMAGE = 'SAVE_SEARCH_IMAGE'
